import { sharedRoutes } from '@/shared-routes';
import { useAuthenticationStore } from '@/stores/authentication/AuthenticationStore';
import { urlWithRedirect } from '@/utils/urlUtils';
import type { RouteLocation } from 'vue-router';

export const AuthGuard = async (to: RouteLocation) => {
  if (useAuthenticationStore().isAuthenticated().value) {
    if (useAuthenticationStore().isVerified().value) {
      return true;
    } else {
      return { path: sharedRoutes.UNVERIFIED };
    }
  } else {
    return urlWithRedirect(
      sharedRoutes.LOGIN,
      to.path !== sharedRoutes.LOGIN && to.path !== sharedRoutes.LOGOUT ? to.fullPath : undefined,
    );
  }
};
